import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import { motion } from 'framer-motion';
import { useRef, KeyboardEvent } from 'react';
interface Props {
  id: string;
  tabs: {
    id: number | string;
    label: string;
    onClick: () => void;
  }[];
  activeTab: number | string;
}
export function TabsButtons(props) {
  const $ = _c(2);
  const {
    id,
    activeTab,
    tabs
  } = props;
  const tabRefs = useRef(new Map());
  const handleKeyDown = (event, currentIndex) => {
    let newIndex;
    bb2: switch (event.key) {
      case "ArrowLeft":
        {
          event.preventDefault();
          newIndex = currentIndex === 0 ? tabs.length - 1 : currentIndex - 1;
          break bb2;
        }
      case "ArrowRight":
        {
          event.preventDefault();
          newIndex = currentIndex === tabs.length - 1 ? 0 : currentIndex + 1;
          break bb2;
        }
      case "Home":
        {
          event.preventDefault();
          newIndex = 0;
          break bb2;
        }
      case "End":
        {
          event.preventDefault();
          newIndex = tabs.length - 1;
          break bb2;
        }
      default:
        {
          return;
        }
    }
    const newTab = tabs[newIndex];
    tabRefs.current.get(newTab.id)?.focus();
    newTab.onClick();
  };
  const t0 = "tablist";
  const t1 = "z-10 flex justify-between rounded-full bg-white p-1";
  const t2 = tabs.map((tab, index) => {
    const isSelected = activeTab === tab.id;
    return <button key={tab.id} ref={el => {
      if (el) {
        tabRefs.current.set(tab.id, el);
      }
    }} role="tab" aria-selected={isSelected} aria-controls={`${id}-panel-${tab.id}`} tabIndex={isSelected ? 0 : -1} onClick={() => tab.onClick()} onKeyDown={e => handleKeyDown(e, index)} className="relative h-13 w-full flex-shrink-1 items-center rounded-full px-2 text-sm leading-4 font-medium text-gray-900 transition focus:bg-transparent"><span className={mergeClasses(activeTab === tab.id && "text-white", "relative z-10 text-sm font-semibold")}>{tab.label}</span>{activeTab === tab.id && <motion.span layoutId={id} className="absolute inset-0 z-0 rounded-full bg-blue-500" transition={{
        type: "spring",
        bounce: 0.2,
        duration: 0.6
      }} aria-hidden="true" />}</button>;
  });
  let t3;
  if ($[0] !== t2) {
    t3 = <div role={t0} className={t1}>{t2}</div>;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  return t3;
}